import { parsePhoneNumber } from 'react-phone-number-input';

/**
 * Handles the onBlur event for phone number inputs.
 * Automatically detects country code from pasted numbers, updates the country selector,
 * and strips the country code and whitespace from the phone number field.
 *
 * @param {string} value - The current value of the phone number input.
 * @param {string} currentCountry - The current selected country code (e.g., '+57').
 * @param {function} setCountry - Function to update the country code state.
 * @param {function} setPhone - Function to update the phone number state.
 */
export const handlePhoneBlurLogic = (value, currentCountry, setCountry, setPhone) => {
    if (!value) return;

    try {
        // Attempt to parse the phone number
        const phoneNumber = parsePhoneNumber(value);

        if (phoneNumber && phoneNumber.country) {
            // It's a valid international number
            const newCountryCode = `+${phoneNumber.countryCallingCode}`;

            // Update country if different
            if (newCountryCode !== currentCountry) {
                setCountry(newCountryCode);
            }

            // Update phone number to national number (strips country code)
            setPhone(phoneNumber.nationalNumber);
        } else {
            // Not a valid international number, or no country detected
            // Just strip whitespace
            const cleaned = value.replace(/\s+/g, '');
            setPhone(cleaned);
        }
    } catch (error) {
        // If parsing fails (e.g. not a phone number), just strip whitespace
        const cleaned = value.replace(/\s+/g, '');
        setPhone(cleaned);
    }
};
